module.exports = __webpack_public_path__ + "static/media/chariotLogo.87eedf76.png";